module.exports = __webpack_public_path__ + "img/cancelSubscription.61b45a21.svg";